import React from "react";

const QuranSearchOverlay = ({
  isOpen,
  usePopupLayout,
  uiLanguage,
  uiLabels,
  searchInputRef,
  searchQuery,
  onSearchQueryChange,
  onClose,
  onSubmit,
  searchSubmitted,
  searchLoading,
  searchError,
  searchTotalResults,
  searchResults,
  onSelectResult,
}) => {
  if (!isOpen) {
    return null;
  }

  const isArabic = uiLanguage === "ar";
  const searchInputDirectionClass = isArabic
    ? "quran-search-input-wrap--rtl"
    : "quran-search-input-wrap--ltr";
  const overlayClassName = usePopupLayout
    ? "quran-search-overlay quran-search-overlay--popup"
    : "quran-search-overlay";
  const content = (
    <>
      <form className={`quran-search-head ${isArabic ? "quran-search-head--rtl" : "quran-search-head--ltr"}`} onSubmit={onSubmit}>
        <div className={`quran-search-input-wrap ${searchInputDirectionClass}`}>
          <input
            ref={searchInputRef}
            className={`quran-search-input ${isArabic ? "quran-search-input--rtl" : "quran-search-input--ltr"}`}
            type="search"
            dir={isArabic ? "rtl" : "ltr"}
            value={searchQuery}
            onChange={(event) => onSearchQueryChange(event.target.value)}
            placeholder={uiLabels.search}
            aria-label={uiLabels.search}
            autoComplete="off"
          />
          <span className="quran-search-icon">⌕</span>
        </div>

        <button
          type="button"
          className="quran-overlay-close-btn quran-search-close"
          onClick={onClose}
        >
          {uiLabels.close}
        </button>
      </form>

      <div className="quran-search-results-wrap">
        {searchSubmitted && !searchLoading && !searchError && (
          <div className="quran-search-results-count">{uiLabels.versesCount} ({searchTotalResults || searchResults.length})</div>
        )}

        {searchLoading && <div className="quran-search-state">{uiLabels.searchInProgress}</div>}
        {!searchLoading && searchError && <div className="quran-search-state quran-search-state--error">{searchError}</div>}

        {!searchLoading && searchSubmitted && !searchError && searchResults.length === 0 && (
          <div className="quran-search-state">{uiLabels.noResults}</div>
        )}

        {!searchLoading && searchSubmitted && !searchError && searchResults.length > 0 && (
          <div className="quran-search-results-list">
            {searchResults.map((result) => (
              <button
                key={`${result.verseKey}-${result.verseId || "result"}`}
                type="button"
                className="quran-search-result-item"
                onClick={() => onSelectResult(result)}
              >
                <div className="quran-search-result-top">
                  <span className="quran-search-result-chapter">
                    {result.chapterName}:{result.verseNumber}
                  </span>
                  <span className="quran-search-result-page">{result.pageNumber || "-"}</span>
                </div>
                <div className="quran-search-result-text">{result.text}</div>
              </button>
            ))}
          </div>
        )}
      </div>
    </>
  );

  return (
    <div
      className={overlayClassName}
      dir={isArabic ? "rtl" : "ltr"}
      onClick={usePopupLayout ? onClose : (event) => event.stopPropagation()}
      onPointerUp={(event) => event.stopPropagation()}
    >
      {usePopupLayout ? (
        <div
          className="quran-search-panel"
          onClick={(event) => event.stopPropagation()}
          onPointerUp={(event) => event.stopPropagation()}
        >
          {content}
        </div>
      ) : (
        content
      )}
    </div>
  );
};

export default QuranSearchOverlay;
